/**
 * Protected Route Component - Requires authentication
 */

import { Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { authService, AuthUser } from '../services/auth-service';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
  requireGroups?: string[];
}

export function ProtectedRoute({ children, requireAdmin, requireGroups }: ProtectedRouteProps) {
  const [user, setUser] = useState<AuthUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const currentUser = await authService.getCurrentUser();
      setUser(currentUser);
    } catch (_err) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !user.groups?.includes('Administrators')) {
    return (
      <div className="p-8 text-center">
        <h2>Access Denied</h2>
        <p>Administrator access required.</p>
      </div>
    );
  }

  if (requireGroups && requireGroups.length > 0) {
    const hasRequiredGroup = requireGroups.some(group => user.groups?.includes(group));
    if (!hasRequiredGroup) {
      return (
        <div className="p-8 text-center">
          <h2>Access Denied</h2>
          <p>You don&apos;t have the required permissions.</p>
        </div>
      );
    }
  }

  return <>{children}</>;
}













